import React, { Component, useState } from "react";
import {
  View,
  Image,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Animated,
  Share,
  ImageBackground,
  FlatList,
  ActivityIndicator,
  Platform,
  Alert,
  RefreshControl,
} from "react-native";
// import { isIos, deviceWidth, deviceHeight, isPastDate, toFixed, getRemainingTime } from './../Utils'
// import Icon from 'react-native-vector-icons/dist/Ionicons';
// import Icons from 'react-native-vector-icons/FontAwesome';
import { Button, Surface } from "react-native-paper";
import EventNote from "@material-ui/icons/EventNote";
import PlayCircleFilled from "@material-ui/icons/PlayCircleFilled";
import Icon from "@material-ui/core/Icon";
import ShowContentScreen from "./../showContentScreen";
import moment from "moment";
import { connect } from "react-redux";

// import AdsScreen from './../Ads';
import {
  getSingleTestInfo,
  clearSingleTestInfoData,
  checkoutCreateTest,
  clearTestSeriesTestList,
  // getUpdateProfile, clearGetUpdateProfile,
} from "./../../store/action";
import Toaster from "./../../components/snackBar_toaster";

// import OfflineHandler from './../OfflineHandler';
import { testDetailsSelector } from "./../../store/selectors";
import PaymentButtonComponent from "./../../components/paymentButton";
import { FOR_TEST_SERIES } from "../../store/constants";
// import Timer from "./../Timer";
import { DateComponent, TimerGifComponent } from "./testSeriesTestList";
import {
  Text,
  Styles,
  TestSeriesTestButton,
} from "./../../components/UI-Components";
import Header from "./../../components/Header/index";
import { TestSeriesDetailsComponent } from "./../../components";
import Container from "@material-ui/core/Container";

import {
  isFixedTest,
  isAnyTimeTest,
  isTimePeriodTest,
  _isUserAttempted,
  _isUserUnAttempted,
  _isUserSubmitted,
  isTestInAnHour,
  isTimeEndForTestStart,
  isPracticeTest,
  isChallengeTest,
  isPlannedTest,
  isAdminTest,
  isTestTimeCompleted,
  isUserAttempted,
  isUserUnAttempted,
  isUserSubmitted,
  isTestCompleted,
  isUserPaid,
  isSelfCreatedTest,
  isSharedTest,
  isUserRejected,
  isUserAcceptedSharedTest,
  isAdminCreatedTest,
  isAcceptedAdminFreeTest,
  isAdminFreeTest,
  isTestSeriesFree,
  isTestSeriesTestFree,
  isTestSeriesUserPaid,
  isPercentageArrayLengthZero,
} from "./testListingValidate";

const wp = (x) => (typeof x === "string" ? x : `${x}%`);
const Loader = require("./../../assets/loadingGif.gif");
const _width = window.innerWidth;

const TestSeriesTestDetailsComponent = ({
  can_user_attempt,
  testSeriesTestId,
  title,
  image_url,
  duration,
  no_of_questions,
  schedule,
  start_date_time,
  end_date_time,
  is_free,
  navigation,
  messageForTest,
  subjectName,
  user_test_status,
  price,
  paymentId,
  mockTestPayment,
  mock_series_code,
  description,
  completed,
  timerChange,
  timerCompleted,
  navigate,
  appStoreProductId,
  video_url,
  ...props
}) => {
  let [_timerCompleted, changeTimerCompleted] = useState(
    isTimeEndForTestStart(start_date_time)
  );

  // console.log(moment(start_date_time) - moment()/1000 < 0);

  const checkTestStartTime = () => {
    changeTimerCompleted(isTimeEndForTestStart(start_date_time));
  };

  const goToScreen = (screen, testSeriesTestId) => {
    props.history.push(screen, {
      testId: testSeriesTestId,
      isTestSeries: true,
    });
  };

  // console.log(props);
  return (
    <View style={{ flex: 1 }}>
      <Surface style={styles.testListWrapper}>
        <View style={styles.testSeries}>
          <View style={styles.leftSideDetails}>
            <Image
              style={styles.testImages}
              source={{ uri: image_url }}
              // resizeMode='center'
            ></Image>
          </View>

          <View style={styles.rightSideDetails}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 20,
              }}
            >
              <Text
                style={styles.testTitle}
                numberOfLines={2}
                ellipsizeMode="tail"
              >
                {title}
              </Text>
            </View>
            <View style={styles.testBottomDetails}>
        
            </View>
          </View>
        </View>
        <View style={styles.dateBox}>
          <DateComponent date={start_date_time} />
          <TimerGifComponent />
          <DateComponent date={end_date_time} />
        </View>
        <View style={styles.bottomDetails}>
          <TestSeriesTestButton
            isUserAccessible={
              isTestSeriesFree(price) ||
              isTestSeriesTestFree(is_free) ||
              isTestSeriesUserPaid(paymentId)
            }
            canUserStart={
              (isTestSeriesFree(price) || is_free || paymentId) &&
              !_isUserSubmitted(user_test_status) &&
              !completed &&
              _timerCompleted &&
              can_user_attempt
            }
            isTestCompleted={_isUserSubmitted(user_test_status) || completed}
            isTestStarted={(moment(start_date_time) - moment()) / 1000 < 0}
            isTestInAnHour={isTestInAnHour(start_date_time)}
            goToScreen={goToScreen}
            testSeriesTestId={testSeriesTestId}
            messageForTest={messageForTest}
            start_date_time={start_date_time}
            checkTestStartTime={checkTestStartTime}
          />
        </View>
      </Surface>

      <Surface style={styles.testListDescription}>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <EventNote
            name={"ios-calendar"}
            size={24}
            style={{
              color: Styles.primaryColor,
            }}
          />
          <Text style={styles.scheduleType}>{schedule}</Text>
        </View>
        <TouchableWithoutFeedback
          onPress={() => {
            navigate.push("FullScreenWebView", {
              description: description,
            });
          }}
        >
          <View style={styles.viewMore}>
            <Text style={styles.buttonViewText}>View More</Text>
          </View>
        </TouchableWithoutFeedback>
      </Surface>
      {video_url && (
        <View style={styles.videoDesWrapper}>
       
          <TouchableWithoutFeedback
            onPress={() => {
              if (_isUserSubmitted(user_test_status) || completed) {
          
                props.openDialog();
                return null;
              }
              return messageForTest("Wait for the test completion", 2000);
            }}
          >
            <View style={styles.VideoButtonComponent}>
              <View mode="contained" style={styles.buttonStyle}>
                <PlayCircleFilled
                  //  name={'play-circle'}
                  //  size={23}
                  style={{
                    color: "#fff",
                    marginLeft: -10,
                    width: 23,
                    height: 23,
                  }}
                />

                <Text style={styles.buttonText}>Explanatory Video</Text>
              </View>
            </View>
          </TouchableWithoutFeedback>
        </View>
      )}

      {!isTestSeriesFree(price) && !paymentId ? (
        <PaymentButtonComponent
          testSeriesName={title}
          price={price}
          onPress={() =>
            mockTestPayment(mock_series_code, price, appStoreProductId)
          }
          //  hasUserPaid={hasUserPaid}
        />
      ) : null}
    </View>
  );
};

const testStartTimeFromNow = (date) => moment(date).fromNow();

class TestDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      test_details: {
        // subject:'History',
        // topic:'Physical Geography',
        // No_test:20,
        // Schedule:'21/03/2019',
        // Duration:40
      },
      timerCompleted: false,
      showContent: false,
    };
  }

  async componentDidMount() {
    this.getTestDetails();
    // this.getUserInfo();
  }

  componentWillUnmount() {
    // this.props.clearSingleTestInfoData();
    // this.props.clearGetUpdateProfile();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.singleTestInfo !== this.props.singleTestInfo) {
      if (this.props.singleTestInfo) {
        this.setState({
          refreshing: false,
          testData: this.props.singleTestInfo,
        });
      }
    }
  }

  getUserInfo = () => {
    // const openedWithNotification = this.props.navigation.getParam('openedWithNotification', false);
    // const openedWithDeepLink = this.props.navigation.getParam('openedWithDeepLink', false);
    // if(openedWithNotification || openedWithDeepLink) {
    //   this.props.getUpdateProfile();
    // }
  };

  // isOpenedWithNotification = () => {
  //   const openedWithNotification = this.props.navigation.getParam('openedWithNotification', false);
  //   const openedWithDeepLink = this.props.navigation.getParam('openedWithDeepLink', false);
  //   return openedWithNotification || openedWithDeepLink
  // }

  // payment = test => {
  //   const openedWithNotification = this.props.navigation.getParam('openedWithNotification', false);
  //   const openedWithDeepLink = this.props.navigation.getParam('openedWithDeepLink', false);

  //   const _testType = this.props.navigation.getParam('testType', null);
  //   const type = test && test.user_rank === 0 ? ADMIN_TEST : CHALLENGE_TEST

  //   if(openedWithDeepLink || openedWithNotification) {
  //     this.props.navigation.push('PaymentScreenForDL', {
  //       paymentInfo: {
  //         testId: test.id,
  //         price: test.bid_amount,
  //         transactionType: FOR_CHALLENGE_TEST,
  //         testName: test.test_name
  //       },
  //       testType: _testType || type || test.test_type,
  //       fromScreen: 'TestDetails',
  //       getTestDetails: this.getTestDetails,
  //       openedWithNotification,
  //       openedWithDeepLink
  //     })
  //     return;
  //   }

  //   this.props.navigation.navigate('PaymentScreen', {
  //     paymentInfo: {
  //       testId: test.id,
  //       price: test.bid_amount,
  //       transactionType: FOR_CHALLENGE_TEST,
  //       testName: test.test_name
  //     },
  //     testType: _testType || type || test.test_type,
  //     fromScreen: 'TestDetails',
  //     getTestDetails: this.getTestDetails,
  //     openedWithNotification,
  //     openedWithDeepLink
  //   })
  // }

  getTestDetails = () => {
    const { location } = this.props;
    const { state } = location || {};
    const {
      testData = {},
      testId = {},
      isTestSeries = false,
      appStoreProductId = null,
      subjectName = [],
    } = state || {};

    if (testData && Object.keys(testData).length === 0 && testId)
      return (testData = { id: testId });
    if (testData) {
      this.props.getSingleTestInfo(testData.id, isTestSeries);
      this.setState({
        // testData,
        test_details: testData,
        subjectName,
        appStoreProductId,
      });
    }
  };

  showToaster = (msg, time = 2000) =>
    this.setState({ show: true, toasterMsg: msg });

  // _onRefresh = () => {
  //   if (this.state.isPlannedTest) {
  //     setTimeout(() => {
  //       this.setState({ refreshing: false })
  //     }, 1000);
  //     return;
  //   }
  //   this.setState({
  //     refreshing: true
  //   }, () => {
  //     console.log(this.state.refreshing);
  //     this.getTestDetails()
  //   });
  // }

  mockTestPayment = (mock_series_code, price) => {
    // alert('not integrated');
    this.props.history.push("Payment", {
      paymentInfo: {
        mockSeriesCode: mock_series_code,
        price: price,
        transactionType: FOR_TEST_SERIES,
        appStoreProductId: this.state.appStoreProductId,
      },
    });
    // this.props.checkoutCreateTest(null, price, null, FOR_TEST_SERIES, mock_series_code)
  };

  // static navigationOptions = ({ navigation }) => {
  //   return {
  //     headerTitle: 'TEST DETAILS',
  //     headerBackground:
  //       (<LinearGradientComponent />),
  //     headerStyle: {
  //       color: StylesColors.headerTextColor,
  //       fontWeight: StylesColors.headerTextFontWeight,
  //       backgroundColor: '#fff',
  //       elevation: 0,
  //       shadowOpacity: 0,
  //       borderBottomWidth: 0,
  //     },
  //     headerTintColor: StylesColors.headerTintColor,
  //     headerTitleStyle: {
  //       color: StylesColors.headerTextColor,
  //       alignItems: 'center',
  //       alignSelf: 'center',
  //       // width: '78%',
  //       textAlign: 'center',
  //       fontWeight: StylesColors.headerTextFontWeight
  //     },
  //   };
  // };

  openDialog = () => {
    this.setState({
      showContent: true,
      contentData: {
        contentUrl: this.props.video_url || "",
        contentType: "video",
        html_content: null,
        title: null,
        id: null,
        subjectId: null,
        examId: null,
        topicId: null,
        formLibrary: false,
      },
    });
  };

  render() {
    const { location } = this.props;
    const { state } = location || {};
    const { paymentId = null, price = null, testType = null, title = null } =
      state || {};
      const {
        testSeriesInfo,
        isTestCompleted,
        canUserAttempt,
        userTestStatus,
        singleTestInfoLoading,
        route
    } = this.props;
    

    // console.log(this.props);

    return (
      <>
        <Header
          title={title}
          headerRight
          headerRightClick={() => this.props.history.push("/Home")}
          headerLeftClick={() => this.props.history.goBack()}
          backButton={true}
        />

        {this.props.singleTestInfoLoading && (
          <View
            style={{
              width: "100%",
              height: "90vh",
              justifyContent: "center",
              alignItems: "center",
              // backgroundColor: "#fff",
              // zIndex: 1000,
            }}
          >
            {/* <ActivityIndicator /> */}
            <Image source={Loader} style={{ width: 250, height: 250 }} />
          </View>
        )}
        {!this.props.singleTestInfoLoading && (
          <Container maxWidth="lg">
            <div
              className="main-component"
              //  style={{flex:1, backgroundColor:Styles.white, height: '90vh', elevation :4, paddingVertical: 30}}
            >
              {/* <View style={{ marginBottom: 0, width: "100%", height: "100%" }}>
                {!this.props.singleTestInfoLoading &&
                this.props.testSeriesTestId &&
                this.props.title ? (
                  <>
                    {
                      <TestSeriesTestDetailsComponent
                        {...this.props}
                        messageForTest={this.showToaster}
                        subjectName={this.props.mock_test_subjects}
                        price={price}
                        paymentId={paymentId}
                        mockTestPayment={this.mockTestPayment}
                        // description={false}
                        appStoreProductId={this.state.appStoreProductId}
                        timerCompleted={this.state.timerCompleted}
                        timerChange={() => {
                          this.setState(
                            {
                              timerCompleted: true,
                            },
                            () => {
                              // alert(JSON.stringify(this.state.timerCompleted))
                            }
                          );
                        }}
                        navigate={this.props.history}
                        // handleClose={this.handleClose}
                        openDialog={this.openDialog}
                      />
                    }
                  </>
                ) : !this.props.singleTestInfoLoading ? (
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text>Not Found</Text>
                  </View>
                ) : null}
              </View> */}
                         {
                !!testSeriesInfo 
                ?
                    <>
                    <View style={{ marginTop: 5, }}> 
                    <TestSeriesDetailsComponent 
                        seriesDetails={testSeriesInfo} 
                        isTestList={false} 
                        explanation={true}
                        isTestCompleted={isTestCompleted}
                        canUserAttempt={canUserAttempt}
                        userTestStatus={userTestStatus}
                        navigation={this.props.history}
                        paymentId={paymentId}
                        _price={price}
                        showToaster={this.showToaster}
                    />
                </View>
                <View style={styles.testDescription}>
                   <View style={{}}>
                       <Text style={{fontSize: 20, fontWeight: '700', color:'#000'}}>About Test</Text>
                   </View>
                   
                   <ScrollView style={{flex: 1, backgroundColor: Styles.fiveMantraBgColor, marginTop: 8 }}>
                   <div style={{flex:1}} dangerouslySetInnerHTML={{__html:this.props.termsConditions}}>
                    </div>
                                
                   {/* <HTML                               
                baseFontStyle={{fontSize: 18,  textAlign: 'justify', color: '#000'}}
                tagsStyles={
                    {
                        h3:{textAlign:'justify'},
                        p:{textAlign:'justify',  fontSize: 18}, ol: {textAlign:'justify', fontSize: 18}, 
                        div:{textAlign:'justify', },
                        span:{textAlign:'justify', }
                    }
                }
                html={this.props.termsConditions} 
                />                            */}
                   </ScrollView>                   
                 </View>
                    </>    
                : null 
                }

            

              <Toaster show={this.state.show} 
                message={this.state.toasterMsg} 
                handleClose={() => this.setState({
                  show: false
                })}
              />
        
              {this.state.showContent && (
                <ShowContentScreen
                  contentData={this.state.contentData}
                  open={this.state.showContent}
                  handleClose={() => this.setState({ showContent: false })}
                />
              )}
            </div>
          </Container>
        )}
      </>
    );
  }
}

const styles = StyleSheet.create({
  fontSize: {
    fontSize: 12,
  },
  roundBorder: {
    flex: 1,
    // height:,
    flexDirection: "row",
    marginTop: 15,
    marginHorizontal: 20,
    width: "95%",
    paddingVertical: 30,
    // borderWidth:0.4,
    // borderColor: '#222',
    padding: 15,
    elevation: 9,
    borderRadius: 10,
    alignSelf: "center",
  },
  flexRow: {
    flexDirection: "row",
    // justifyContent: 'center',
    // alignItems: 'center',
  },
  searchIcon: {
    marginRight: 10,
    paddingRight: 10,
    color: "#b3b3b3",
  },
  headingColor: {
    color: Styles.primaryColor,
    width: "50%",
    fontWeight: "700",
  },
  scene: {
    flex: 1,
  },
  tabBar: {
    flexDirection: "row",
    // paddingTop: Constants.statusBarHeight,
  },
  tabItem: {
    flex: 1,
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    fontSize: 30,
    // borderRightWidth: 1,
    // borderColor: Styles.dangerColor
  },
  button: {
    // width: deviceWidth-30,
    marginVertical: 8,
    width: "100%",
  },
  imageRes: {
    ...Platform.select({
      ios: {
        // borderRadius:40,
        width: 100,
        height: 100,
      },
      android: {
        // borderRadius:80,
        width: 100,
        height: 100,
      },
    }),
  },
  testListWrapper: {
    elevation: 8,
    marginVertical: 10,
    // marginHorizontal: 10,
    width: wp("95%"),
    // height: hp('25%'),
    borderRadius: 15,
    alignSelf: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
  },

  testListDescription: {
    elevation: 5,
    alignSelf: "center",
    width: wp("95%"),
    borderRadius: 15,
    // flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 16,
    paddingHorizontal: 12,
  },
  testSeries: {
    flexDirection: "row",
    marginVertical: 10,
    // marginHorizontal: 10,
    // height: hp(10),
    // backgroundColor: 'green'
  },
  leftSideDetails: {
    // width: wp('10%'),
    // height: hp(10),
    // marginVertical: hp(1.5)
    minWidth: _width >= 578 ? 150 : 56,
    minHeight: _width >= 578 ? 150 : 56,
    marginRight: 12,
  },
  testImages: {
    height: "100%",
    width: "100%",
    borderRadius: 100,
    // resizeMode: 'cover'
  },
  timerIcon: {
    //  backgroundColor:'#f00',
    width: 32,
    height: 32,
    borderRadius: 50,
    marginHorizontal: 5,
    marginVertical: 15,
  },
  testTitle: {
    fontSize: 16,
    fontWeight: "500",
    // width: '100%',
    color: "#000000",
    // marginVertical: 12,
    // fontWeight: '500',
    textTransform: "capitalize",
    fontFamily: Styles.primaryFontFamily,
  },
  rightSideDetails: {
    // width: wp('80%'),
    // height: hp(10),
    flex: 1,
    flexDirection: "column",
    // backgroundColor: 'blue'
  },
  underLine: {
    width: "80%",
    borderColor: Styles.testSeriesListColor,
    borderWidth: 0.2,
    marginVertical: 5,
  },
  testBottomDetails: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  subjectComponent: {
    paddingBottom: 2,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 2,
    alignItems: "center",
    opacity: 0.6,
    backgroundColor: "#e9e9e9",
    marginVertical: 8,
  },
  listOfBoxes: {
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: 2,
    flexWrap: "wrap",
  },
  subjectBoxTitle: {
    fontSize: 8,
    color: Styles.testSeriesListColor,
    fontFamily: Styles.primaryFontFamily,
  },
  timeStart: {
    color: Styles.testSeriesListColor,
    fontSize: 9,
  },
  timeEnd: {
    color: Styles.testSeriesListColor,
    fontSize: 9,
  },
  dateTitle: {
    fontSize: 9,
    color: Styles.testSeriesListColor,
    marginLeft: 5,
  },
  testStartButton: {
    width: 75,
    //  height: 25,
    backgroundColor: Styles.bgDark,
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "center",
    justifyContent: "space-between",
    borderRadius: 10,
    elevation: 5,
    paddingHorizontal: 8,
    paddingVertical: 8,
  },
  buttonTitle: {
    fontSize: 10,
    color: "#fff",
    marginLeft: 5,
    fontFamily: Styles.primaryFontFamily,
  },
  arrowStyle: {
    color: Styles.White,
    fontSize: 12,
  },
  description: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    padding: 32,
    borderWidth: 1,
    // height: '100%'
  },
  scheduleType: {
    textTransform: "uppercase",
    marginLeft: 10,
    // height: 30
  },
  descHeader: {
    fontSize: 15,
    color: "#262626",
    fontFamily: Styles.primaryFontFamily,
  },
  descSubTitle: {
    fontSize: 11,
    color: "#292929",
    fontFamily: Styles.primaryFontFamily,
  },
  viewMore: {
    width: 75,
    height: 25,
    //  height:hp(3),
    backgroundColor: Styles.primaryColor,
    flexDirection: "row",
    cursor: 'pointer',
    //  marginRight:4,
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 10,
    //  shadowColor: Styles.primaryColor,
    //  shadowRadius: 10,
    //  shadowOpacity: 0.6,
    elevation: 5,
    //  shadowOffset: {width: 0,height: 4},
    paddingHorizontal: 5,
    paddingVertical: 5,
    //  marginHorizontal:200
    // marginRight:10
    justifyContent: "center",
    alignItems: "center",
  },
  buttonStyle: {
    width: 300,
    backgroundColor: Styles.primaryColor,
    //  marginRight:4,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 15,

    paddingHorizontal: 10,
    paddingVertical: 10,
    alignSelf: "center",
    flexDirection: "row",
  },
  buttonText: {
    color: "#fff",
    fontSize: 20,
    fontFamily: Styles.primaryFontFamily,
    marginLeft: 10,
  },
  buttonPlayIcon: {
    color: "#fff",
    marginLeft: -10,
    width: 23,
    height: 23,
  },
  buttonViewText: {
    fontSize: 10,
    color: "#fff",
  },
  descSubDesc: {
    fontSize: 11,
    color: "#292929",
    marginVertical: 10,
    fontFamily: Styles.primaryFontFamily,
  },
  dateBox: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "center",
    // flex: 1,
    paddingHorizontal: 12,
    paddingVertical: 12,
    // borderBottomWidth: 0.4,
    borderColor: "#ccc",
    // backgroundColor: 'red'
    // borderWidth: 1,
    // marginBottom: 4
    width: "100%",
  },
  textColor: {
    color: "#f00",
  },
  startTime: {
    width: wp(15),
    flexDirection: "column",
    marginHorizontal: wp(4.5),
    alignSelf: "center",
  },
  endTime: {
    width: wp(30),
    alignSelf: "center",
    flexDirection: "column",
    marginHorizontal: wp(5),
  },
  middleBox: {
    width: wp(40),
    justifyContent: "flex-start",
    alignSelf: "center",
    marginHorizontal: wp(2.5),
  },
  startDate: {
    fontSize: wp(2),
    color: "#555",
    fontFamily: Styles.primaryFontFamily,
  },
  timeStart: {
    fontSize: wp(2),
    color: "#555",
    marginHorizontal: wp(1),
    fontFamily: Styles.primaryFontFamily,
  },
  timeZone: {
    fontSize: wp(3),
    color: "#555",
    fontFamily: Styles.primaryFontFamily,
  },
  leftSymbols: {
    marginHorizontal: wp(1),
    color: "#3758DB",
    fontSize: wp(3),
  },
  rightSymbols: {
    marginHorizontal: wp(1),
    color: "#3758DB",
    fontSize: wp(3),
  },
  bottomDetails: {
    // width: wp(95),
    justifyContent: "center",
    alignItems: "center",
    // borderWidth: 1,
    marginBottom: 8,
  },
  winnerPrizeBackground: {
    marginHorizontal: 20,
    width: wp(97),
    height: 65,
    alignSelf: "center",
  },
  winnerPrizeWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    paddingLeft: 15,
    paddingRight: 35,
    height: 65,
    flex: 1,
    borderRadius: 10,
  },
  prizePollWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    marginHorizontal: 40,
    marginTop: 10,
    flex: 1,

    flexWrap: "wrap",
  },
  bottomPrizeWrapper: {
    flex: 1,
    justifyContent: "space-around",
    alignItems: "center",
    flexDirection: "row",
    marginHorizontal: 70,
    marginTop: 10,
  },
  prizePool: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  prizeText: {
    fontSize: 14,
    color: "#fff",
    fontWeight: "700",
    marginLeft: 5,
  },
  winnerPrizeRightSide: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    marginHorizontal: 4,
  },
  winnerPrizeText: {
    color: Styles.white,
    fontSize: 14,
    fontWeight: "700",
    fontFamily: Styles.primaryFontFamily,
    textTransform: "uppercase",
    lineHeight: 20,
  },
  winnerPrizeTotalText: {
    color: Styles.white,
    fontSize: 24,
    fontWeight: "700",
    fontFamily: Styles.primaryFontFamily,
    textTransform: "uppercase",
    // marginEnd: 40
  },
  rankStyle: {
    width: 18,
    height: 18,
  },
  moneyBagImage: {
    width: 64,
    height: 60,
  },
  videoDesHeader: {
    fontSize: 16,
    fontWeight: "600",
    color: "#000",
    marginLeft: 4,
  },
  videoDesWrapper: {
    width: "95%",
    alignSelf: "center",
    marginTop: 16,
    flex: 1,
  },

  VideoButtonComponent: {
    marginTop: 20,
  },
});

const mapStateToProps = (state) => {
  const testSeriesTestDetails = testDetailsSelector(state);
  const {
    time_remaining_to_start,
    time_remaining_to_end,
    can_user_attempt,
    id: testSeriesTestId,
    title,
    image_url,
    duration,
    no_of_questions,
    schedule,
    start_date_time,
    end_date_time,
    is_free,
    error,
    user_test_status,
    mock_series_code,
    mock_test_subjects,
    completed,
    description,
    video_url,
  } = testSeriesTestDetails;

  return {
    // userNameFormProfile:
    //   state.getUpdateProfile &&
    //   state.getUpdateProfile.response &&
    //   state.getUpdateProfile.response.user &&
    //   state.getUpdateProfile.response.user.username,
    // userProfilePic:
    //   state.getUpdateProfile &&
    //   state.getUpdateProfile.response &&
    //   state.getUpdateProfile.response.user &&
    //   state.getUpdateProfile.response.user.profile_pic,
    // userProfileUrl:
    //   state.homeData &&
    //   state.homeData.userDetails &&
    //   state.homeData.userDetails.profile_pic,
    // userName:
    //   state.homeData &&
    //   state.homeData.userDetails &&
    //   state.homeData.userDetails.username,
    // singleTestInfoLoading: state.singleTestInfo && state.singleTestInfo.loading,
    // singleTestInfoError: state.singleTestInfo && state.singleTestInfo.error,
    // singleTestInfoErrorInfo:
    //   state.singleTestInfo && state.singleTestInfo.errorInfo,
    // singleTestInfo:
    //   state.singleTestInfo &&
    //   state.singleTestInfo.response &&
    //   state.singleTestInfo.response.testDetails,
    // subjectDetails:
    //   state.singleTestInfo &&
    //   state.singleTestInfo.response &&
    //   state.singleTestInfo.response.subjectDetails,
    // acceptedUsers:
    //   state.singleTestInfo &&
    //   state.singleTestInfo.response &&
    //   state.singleTestInfo.response.acceptedUsers,
    // acceptedUsersCount:
    //   state.singleTestInfo &&
    //   state.singleTestInfo.response &&
    //   state.singleTestInfo.response.acceptedUsers &&
    //   state.singleTestInfo.response.acceptedUsers.length,
    // rejectedUsers:
    //   state.singleTestInfo &&
    //   state.singleTestInfo.response &&
    //   state.singleTestInfo.response.rejectedUsers,
    // createdUser:
    //   state.singleTestInfo &&
    //   state.singleTestInfo.response &&
    //   state.singleTestInfo.response.createdUser,
    // testInviteResponseLoading:
    //   state.testInviteResponse && state.testInviteResponse.loading,
    // testInviteResponseError:
    //   state.testInviteResponse && state.testInviteResponse.error,
    // testInviteResponseErrorInfo:
    //   state.testInviteResponse &&
    //   state.testInviteResponse.errorInfo &&
    //   state.testInviteResponse.errorInfo.response &&
    //   state.testInviteResponse.errorInfo.response.data &&
    //   state.testInviteResponse.errorInfo.response.data.message,
    // testInviteResponseInfo:
    //   state.testInviteResponse &&
    //   state.testInviteResponse.response &&
    //   state.testInviteResponse.response.status,
    // percentages:
    //   state.singleTestInfo &&
    //   state.singleTestInfo.response &&
    //   state.singleTestInfo.response.testDetails &&
    //   state.singleTestInfo.response.testDetails.percentages,

    // testSeriesTestId,
    // title,
    // image_url,
    // duration,
    // no_of_questions,
    // schedule,
    // start_date_time,
    // end_date_time,
    // is_free,
    // error,
    // can_user_attempt,
    // user_test_status,
    // mock_series_code,
    // mock_test_subjects,
    // completed,
    // description,
    // video_url,
    // fundAccountStatus:
    //   state.homeData &&
    //   state.homeData.res &&
    //   state.homeData.res.user_details &&
    //   state.homeData.res.user_details.fundAccountStatus,
    singleTestInfoLoading: state.singleTestInfo && state.singleTestInfo.loading,
    singleTestInfoError: state.singleTestInfo && state.singleTestInfo.error,
    singleTestInfoErrorInfo: state.singleTestInfo && state.singleTestInfo.errorInfo,
    singleTestInfo: state.singleTestInfo && state.singleTestInfo.response && state.singleTestInfo.response.testDetails,
    subjectDetails: state.singleTestInfo && state.singleTestInfo.response && state.singleTestInfo.response.subjectDetails,
    testSeriesInfo: state.singleTestInfo?.response?.mock_test_details,
    termsConditions: state.singleTestInfo?.response?.mock_test_details?.termsconditions,
    isTestCompleted: state.singleTestInfo?.response?.completed,
    canUserAttempt: state.singleTestInfo?.response?.can_user_attempt,
    userTestStatus: state.singleTestInfo?.response?.user_test_status,
  };
};

export default connect(mapStateToProps, {
  getSingleTestInfo,
  clearTestSeriesTestList,
  clearSingleTestInfoData,
  checkoutCreateTest,
  //  getUpdateProfile, clearGetUpdateProfile,
})(TestDetails);
